module.exports = __webpack_public_path__ + "img/0220809161449.a74baff1.jpg";